module.exports={
	"Form": "PhysicalAssetElementTypeCreateManifest",
	"Scope": "PhysicalAssetElementType-Create",
	"Descriptors":
	{
		"PhysicalAssetElementTypeDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetElementType-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Identity",
				"Group": "PhysicalAssetElementType-Create-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.SectionCode":
		{
			"Name": "Section Code",
			"Hash": "PhysicalAssetElementType-Create-SectionCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Identity",
				"Group": "PhysicalAssetElementType-Create-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetElementType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "PhysicalAssetElementType-Create-Identity",
				"Group": "PhysicalAssetElementType-Create-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Section":
		{
			"Name": "Section",
			"Hash": "PhysicalAssetElementType-Create-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Unit":
		{
			"Name": "Unit",
			"Hash": "PhysicalAssetElementType-Create-Unit",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Clarification":
		{
			"Name": "Clarification",
			"Hash": "PhysicalAssetElementType-Create-Clarification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetMaterial":
		{
			"Name": "Physical Asset Material",
			"Hash": "PhysicalAssetElementType-Create-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details",
				"Entity": "PhysicalAssetMaterial",
				"SearchFields":
				[
					"Code",
					"Description"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetElementType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetElementType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetElementType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetElementType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
